import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { ConfirmationPayload } from '../../interfaces';
import { BotChatCard } from '@/shared/components';
import { BotChatCardType } from '@/shared/enums';

@Component({
  selector: 'bevvi-confirmation-payload',
  imports: [BotChatCard],
  templateUrl: './confirmation-payload.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationPayloadComponent {
  public readonly payload = input.required<ConfirmationPayload>();
  public readonly disabled = input(false);

  public readonly userReply = output<string>();

  protected readonly type = BotChatCardType;

  protected readonly primaryOption = computed(() =>
    this.payload().options.find((option) => option.type === 'yes'),
  );

  protected readonly secondaryOption = computed(() =>
    this.payload().options.find((option) => option.type === 'no'),
  );

  public onPrimaryClick(): void {
    const option = this.primaryOption();
    if (!option) return;
    this.userReply.emit(option.label);
  }

  public onSecondaryClick(): void {
    const option = this.secondaryOption();
    if (!option) return;
    this.userReply.emit(option.label);
  }
}
